<script>export let linkText = "";
export let linkUrl = "";
export let targetType = "_blank";
export let linkMarkup = "";
export let classNames = "";
</script>

<div class={`link ${classNames}`}>
    {#if linkMarkup}
        <a
            href={linkUrl}
            target={targetType}
        >
            {@html linkMarkup}
        </a>
    {:else if linkText}
        <a
            href={linkUrl}
            target={targetType}
        >
            {linkText}
        </a>
    {:else}
        <a
            href={linkUrl}
            target={targetType}
        >
            {linkUrl}
        </a>
    {/if}
</div>

<style>@charset "UTF-8";
:root {
  --pol-site-theme-primary-color: 0, 113, 206;
  --pol-site-theme-secondary-color: 245, 246, 234;
  --pol-site-theme-tertiary-color: #0076de;
  --pol-site-primary-color: var(--pol-site-theme-primary-color);
  --pol-site-secondary-color: var(--pol-site-theme-secondary-color);
  --pol-site-tertiary-color: var(--pol-site-theme-tertiary-color);
}

/* Allrecipes theme */
.site-allrecipes {
  --pol-site-theme-primary-color: 213, 66, 21;
  --pol-site-theme-secondary-color: 231, 171, 70;
  --pol-site-theme-tertiary-color: 245, 246, 234;
  --pol-site-primary-color: var(--pol-site-theme-primary-color);
  --pol-site-secondary-color: var(--pol-site-theme-secondary-color);
  --pol-site-tertiary-color: var(--pol-site-theme-tertiary-color);
}

/* Better Homes & Gardens theme */
.site-bhg {
  --pol-site-theme-primary-color: 75, 80, 170;
  --pol-site-theme-secondary-color: 200, 58, 162;
  --pol-site-theme-tertiary-color: 241, 242, 255;
  --pol-site-primary-color: var(--pol-site-theme-primary-color);
  --pol-site-secondary-color: var(--pol-site-theme-secondary-color);
  --pol-site-tertiary-color: var(--pol-site-theme-tertiary-color);
}

/* Eating Well theme */
.site-eatingwell {
  --pol-site-theme-primary-color: 0, 102, 70;
  --pol-site-theme-secondary-color: 97, 158, 69;
  --pol-site-theme-tertiary-color: 228, 241, 239;
  --pol-site-primary-color: var(--pol-site-theme-primary-color);
  --pol-site-secondary-color: var(--pol-site-theme-secondary-color);
  --pol-site-tertiary-color: var(--pol-site-theme-tertiary-color);
}

/* Food & Wine theme */
.site-foodandwine {
  --pol-site-theme-primary-color: 66, 148, 255;
  --pol-site-theme-secondary-color: 231, 31, 61;
  --pol-site-theme-tertiary-color: 238, 238, 240;
  --pol-site-primary-color: var(--pol-site-theme-primary-color);
  --pol-site-secondary-color: var(--pol-site-theme-secondary-color);
  --pol-site-tertiary-color: var(--pol-site-theme-tertiary-color);
}

/* Health theme */
.site-health {
  --pol-site-theme-primary-color: 26, 127, 130;
  --pol-site-theme-secondary-color: 251, 217, 206;
  --pol-site-primary-color: var(--pol-site-theme-primary-color);
  --pol-site-secondary-color: var(--pol-site-theme-secondary-color);
}

/* Martha Stewart theme */
.site-marthastewart {
  --pol-site-theme-primary-color: 153, 38, 30;
  --pol-site-theme-secondary-color: 245, 246, 234;
  --pol-site-primary-color: var(--pol-site-theme-primary-color);
  --pol-site-secondary-color: var(--pol-site-theme-secondary-color);
}

/* Midwest Living theme */
.site-midwestliving {
  --pol-site-theme-primary-color: 213, 66, 21;
  --pol-site-theme-secondary-color: 244, 67, 54;
  --pol-site-primary-color: var(--pol-site-theme-primary-color);
  --pol-site-secondary-color: var(--pol-site-theme-secondary-color);
}

/* My Recipes theme */
.site-myrecipes {
  --pol-site-theme-primary-color: 0, 98, 101;
  --pol-site-theme-secondary-color: 153, 198, 199;
  --pol-site-primary-color: var(--pol-site-theme-primary-color);
  --pol-site-secondary-color: var(--pol-site-theme-secondary-color);
}

/* People en Español theme */
.site-peopleenespanol {
  --pol-site-theme-primary-color: 0, 98, 101;
  --pol-site-theme-secondary-color: 153, 198, 199;
  --pol-site-primary-color: var(--pol-site-theme-primary-color);
  --pol-site-secondary-color: var(--pol-site-theme-secondary-color);
}

/* Parents theme */
.site-parents {
  --pol-site-theme-primary-color: 0, 98, 101;
  --pol-site-theme-secondary-color: 254, 224, 207;
  --pol-site-primary-color: var(--pol-site-theme-primary-color);
  --pol-site-secondary-color: var(--pol-site-theme-secondary-color);
}

/* Rachael Ray Magazine theme */
.site-rachaelraymag {
  --pol-site-theme-primary-color: 229, 16, 108;
  --pol-site-theme-secondary-color: 249, 207, 225;
  --pol-site-primary-color: var(--pol-site-theme-primary-color);
  --pol-site-secondary-color: var(--pol-site-theme-secondary-color);
}

/* Real Simple theme */
.site-realsimple {
  --pol-site-theme-primary-color: 229, 16, 108;
  --pol-site-theme-secondary-color: 249, 207, 225;
  --pol-site-primary-color: var(--pol-site-theme-primary-color);
  --pol-site-secondary-color: var(--pol-site-theme-secondary-color);
}

/* Southern Living theme */
.site-southernliving {
  --pol-site-theme-primary-color: 153, 38, 30;
  --pol-site-theme-secondary-color: 245, 246, 234;
  --pol-site-primary-color: var(--pol-site-theme-primary-color);
  --pol-site-secondary-color: var(--pol-site-theme-secondary-color);
}

/* Shape theme */
.site-shape {
  --pol-site-theme-primary-color: 153, 38, 30;
  --pol-site-theme-secondary-color: 245, 246, 234;
  --pol-site-primary-color: var(--pol-site-theme-primary-color);
  --pol-site-secondary-color: var(--pol-site-theme-secondary-color);
}

.link--biu a, .link--biu-inline a {
  color: rgba(0, 0, 0, 0.95);
  text-decoration-color: rgb(var(--pol-site-primary-color));
}
.link--biu a:hover, .link--biu a:visited, .link--biu-inline a:hover, .link--biu-inline a:visited {
  text-decoration: underline;
  text-decoration-color: rgb(var(--pol-site-primary-color));
}
.link--rmni a {
  align-items: center;
  border-width: 1px;
  border-style: solid;
  color: black;
  display: flex;
  font: 10px/20px var(--pol-theme-secondary-font-family);
  font-weight: 700;
  justify-content: center;
  text-decoration: none;
  width: 64px;
}
.link--rmni a:hover {
  text-decoration: none;
}</style>
